var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.dataLoaded)?_c('div',{class:{ 'is-mobile': _vm.isMobile, obscure: _vm.spallaState }},[_c('my-header'),_c('router-view')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }